module.exports = __webpack_public_path__ + "static/media/water1.b754f646.jpg";